export const HOME_ELECTRONICS = 'HOME ELECTRONICS';
export const HOME_ELCTRNCS = 'HOME ELCTRNCS';
export const HOMEE = 'HOMEE';
export const CONSUMER_ELECTRONICS = 'Consumer Electronics';
export const CONSUMER_ELECTRONICS_TXU = 'Consumer Electronics TXU';
export const CE_URL = 'https://cinchelectronics.com/';
